import {TabletDatum} from './tablet_datum';
import {BaseSerializer} from '../base/base.serializer';
import {TabletSerializer} from '../tablets/tablet.serializer';

export class TabletDatumSerializer extends BaseSerializer<TabletDatum> {
  fromJson(json: any): TabletDatum {
    const serialized = new TabletDatum(json);
    if (json.tablet) {
      serialized.tablet = new TabletSerializer().fromJson(json.tablet);
    }
    return serialized;
  }

  toJson(obj: TabletDatum): string {
    let params: any = {tablet_datum: obj};
    params = JSON.parse(JSON.stringify(params));
    return params;
  }
}
